import {activationSteps, activationPhases, activationSubSteps} from "constants/constants";
import {getConstant, isConstantExist} from "utils/helpers";
import {useTranslation} from "react-i18next";

export const useCourierOnboarding = () => {
    const {t} = useTranslation();
    const renderOnboardingStatus = ({activationStep}) => {
        return isConstantExist(activationSteps, activationStep)
            ? t(getConstant(activationSteps, activationStep).translation_key, {
                  ns: "activationSteps"
              })
            : "-";
    };

    const renderOnboardingStep = ({activationPhase}) => {
        return isConstantExist(activationPhases, activationPhase)
            ? t(getConstant(activationPhases, activationPhase).translation_key, {
                  ns: "activationPhases"
              })
            : "-";
    };

    const renderOnboardingSubStatus = ({activationSubStep, activationStep}) => {
        return isConstantExist(activationSubSteps, activationSubStep)
            ? t(getConstant(activationSubSteps, activationSubStep).translation_key, {
                  ns: "activationSubSteps"
              })
            : "-";
    };

    return {
        renderOnboardingStatus,
        renderOnboardingStep,
        renderOnboardingSubStatus
    };
};
